import { HttpClient } from '../../protocols/http/httpClient'
import {
  IStandaloneBillings,
  StandaloneBillings
} from '../../../domain/usecases/StandaloneBillings'
import {
  StandaloneBilling,
  StandaloneBillingListResponse
} from '../../../domain/models/StandaloneBillingModel'
import { throwIfHttpError } from '../../../validation/httpError'

export class RemoteStandaloneBillings implements IStandaloneBillings {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async create(
    params: StandaloneBillings.CreateParams
  ): Promise<StandaloneBilling> {
    const response = await this.httpClient.post?.({
      url: `${this.url}/standalone-billings`,
      data: params
    })
    return throwIfHttpError(response, 'Erro ao criar cobrança avulsa')
  }

  async list(
    params: StandaloneBillings.ListParams
  ): Promise<StandaloneBillingListResponse> {
    return this.httpClient.get?.({
      url: `${this.url}/standalone-billings`,
      data: params
    })
  }

  async getOne({
    id
  }: StandaloneBillings.GetParams): Promise<StandaloneBilling> {
    return this.httpClient.get?.({
      url: `${this.url}/standalone-billings/${id}`
    })
  }

  async cancel({
    id
  }: StandaloneBillings.CancelParams): Promise<StandaloneBilling> {
    const response = await this.httpClient.post?.({
      url: `${this.url}/standalone-billings/${id}/cancel`,
      data: {}
    })
    return throwIfHttpError(response, 'Erro ao cancelar cobrança')
  }
}
